import React, {ReactNode} from "react";
import DomHelper from "../../helper/DomHelper";
import Translate from "../../translation/Translate";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class CompletedStamp extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let id: string = "gradient-" + DomHelper.generateUUID();

		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox={"0 0 300 60"}>
				<g style={{
					opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
					transformOrigin: "50% 50%"
				}}>
					<defs>
						<linearGradient id={id} x1={0} x2="100%" y1={0} y2={0}>
							<stop offset={0} style={{stopOpacity: 1, stopColor: "#F0F4F0"}}/>
							<stop offset="100%" style={{stopOpacity: 1, stopColor: "#D1E2D9"}}/>
						</linearGradient>
					</defs>
					{FunctionHelper.exists(this.props.onMoveStart) &&
						<rect x={1} y={1} rx={5} ry={5} width={298} height={58} className="movearea"
                              onClick={this.props.onClick} onContextMenu={this.props.onContextMenu}
							  onPointerDown={this.props.onMoveStart}/>
					}
					<rect x={1} y={1} rx={5} ry={5} width={298} height={58} style={{
						fill: "#F0F4F0",
						strokeWidth: 1,
						stroke: "#418349"
					}}/>
					<text x={"50%"} y={"50%"} dominantBaseline={"central"} style={{
						fontWeight: "bold",
						fontStyle: "italic",
						textAnchor: "middle",
						textTransform: "uppercase",
						fill: "#418349",
						fontSize: "30px"
					}}>
						<Translate {...this.props} data="annotation.stamp_types.completed" namespace="sidebar"/>
					</text>
				</g>
			</svg>
		);
	}
}